// extracted by mini-css-extract-plugin
export default {"homePage":"HomePage_homePage__1zL1Q","feedback":"HomePage_feedback__WqXfH","termsButton":"HomePage_termsButton__56JRw"};